import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { loginCrdential, getUser } from "../../Services/authService";
import { getCustomer, getLogo } from "../../Services/customerServices";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import InputTextElementElement from "../UiComponents/InputTextElement";
import ButtonElement from "../UiComponents/ButtonElement";
import { useLoginPermissionProvider } from "../../Providers/LoginPermissionProvider";
import {
  useCustomerContext,
} from "../../Providers/CustomerProvider";
import Loader from "../UiComponents/Loader";
import useToggle from "../../Hooks/useToggle";
import { Message } from "primereact/message";
import socket from "../../socket";
import _ from "lodash";
import { getAllUsers } from "../../Services/userService";

export const Login = () => {
  const {
    setCustomerData,
  } = useCustomerContext();
  const [loader, setLoader] = useToggle();
  const passwordRef = useRef(null); 

  const currVersion = "";
  const versions = [];
  const [data, setData] = useState({
    username: "",
    password: "",
  });
  const [userdata, setUserData] = useState({
    isAdmin: "",
    isBranchAdmin: "",
    isRestricted: "",
    acceptGdpr: "",
    curCustomer: "",
    short_name: "",
    currCustomer: "",
  });
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [browserId,setBrowserId]= useState("")
  const { fetchUserData } = useLoginPermissionProvider()

  // condtion for checking
  const navigate = useNavigate();
  const branch = useRef(null);

  function handleEvent(e) {
    setData((allData) => ({
      ...allData,
      [e.target.name]: e.target.value,
    }));
    !passwordRef.current?.value && setShowPassword(false);
  }

  const loadPage = async function (currCustomer, currentPage, user) {
    localStorage.setItem("enduser", JSON.stringify(user.data));
    localStorage.setItem(
      "user_privileges",
      JSON.stringify(user.data.user_privileges)
    );
    fetchUserData();
    const customerDAta = await getCustomer(currCustomer);
    if (customerDAta && customerDAta.data.version_maintained.length == 1) {
      currVersion = "v1";
    } else {
      for (var i = 0; i < customerDAta.data.version_maintained.length; i++) {
        if (
          customerDAta.data.version_maintained[i].module_name.toLowerCase() ==
          "dashboard"
        ) {
          versions.push(customerDAta.data.version_maintained[i].version_detail);
        }
      }
      const short_name = userdata.short_name;
      if (currentPage == "Dashboard") {
        navigate(`/dashboard/${customerDAta.data.customer_short}`);
      }
      else {
        navigate(`/portfolio}`);
      }
    }
  };
 
  const getAllUser = async () =>{
    var paginationOptions = {
      pageNumber: 1,
      pageSize: 10,
      sort: null
  };
    const user = await getUser();

    if (user && user.data) {
      // const uuser = JSON.parse(localStorage.getItem("enduser"));
      const searchSeqId = ""
      const filter = 'All'
      const sortBy =  "last_login"
      const orderBy = -1
      var skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
      var limit = skip + paginationOptions.pageSize;
      const getUserResponse = await getAllUsers(user.data.customer_id, user.data.username, searchSeqId, filter, sortBy, orderBy, skip, limit, user.data.branch)
    }
  }
  

  const handleSubmit = async (e) => {
    setLoader();
    if (data.username && data.password) {
      const response = data && await loginCrdential(data);
      if (response && response.success) {
        localStorage.setItem('credentials',JSON.stringify(data.username))
        const user = await getUser();

        if (user && user.data) {
          const userData = {
            username: user.data.username,
            email: user.data.email,
          };
          localStorage.setItem("enduser", JSON.stringify(userData));
          const currCustomer = user.data.customer;
          socket.emit('login',{browserId: user.data.uniqid, customer_id: currCustomer})

          const dashboardFrom = "homePage";

          const customerDAta = await getCustomer(currCustomer);
          if (customerDAta && customerDAta.status == 200) {
            setUserData((prevdata) => ({
              ...prevdata,
              ["isAdmin"]: user.data.isAdmin,
              ["isBranchAdmin"]: user.data.isBranchAdmin,
              ["acceptGdpr"]: user.data.acceptGdpr,
              ["isRestricted"]: user.data.isRestricted,
              ["curCustomer"]: user.data.customer,
              ["short_name"]: user.data.customer_short,
              ["currCustomer"]: user.data.customer,
            }));
            setCustomerData(customerDAta);
            const logopath = await getLogo(currCustomer);
            const customerID = currCustomer;

            if (
              user?.data?.user_device !== null &&
              user?.data?.user_device == window.navigator.userAgent &&
              user?.data?.mfadevice_expired_on !== null &&
              moment(user?.data?.mfadevice_expired_on).isAfter(moment()) == true
            ) {
              if (user.data.isRestricted) {
                loadPage(currCustomer, "Opportunity", user);
              } else {
                loadPage(currCustomer, "Dashboard", user);
              }
            } else {
              navigate("/mfa");
            }
          }
        }
      } else {
        setMessage(response?.message);
        localStorage.clear()
      }
    }
    setLoader(); // Toggle loader off after the action is completed
  };
  branch.current = browserId
  useEffect(() => {
    // Define the event listener for 'getBrowserId'
    socket.on('getBrowserId', async () => {
      const user = await getUser();
      if(user){
        if (!_.isEmpty(user.data.uniqid)) {
          var enduser = localStorage.getItem("enduser")
          if (enduser) {
            const uuser = JSON.parse(enduser);
            if (uuser && uuser.customer) {
              socket.emit('bindBrowserId', { browserId: user.data.uniqid, customer_id: uuser.customer });
            }else {
              navigate("/login")
              localStorage.clear()
            }
          }
        }
      }
     
    });

   

  }, []);
  useEffect(()=>{
    socket.on('update', () => {
      getAllUser();
    });
  },[])
  const handleForgotPassword = () => {
    navigate("/forgotPassword");
  };

  useEffect(() => {
    const alreadyLogin = localStorage.getItem("enduser");
    if (alreadyLogin) {
      navigate("/login");
    }
    const handleKeyPress = (e) => {
      if (e.key === "Enter") {
        handleSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [data]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className="">
        <div className="row mt-0">
          <div className="col-lg-7 col-md-7 d-none d-md-block gradient-bg">
            <div className="d-flex flex-column justify-content-center align-items-center h-100">
              <img
                src="./images/esg.svg"
                alt="testing error"
                className="mb-3 w-25"
              />
              <div className="d-flex flex-columnjustify-content-center align-items-center">
                <h3 className="text-left text-white">
                  ESG made Easy - to <br />
                  operationalise ESG across your
                  <br />
                  Organisation
                </h3>
              </div>
            </div>
          </div>
          <div className="d-flex flex-column justify-content-center align-items-center col-lg-5 col-md-5 col-sm-12">
            <div className="d-flex justify-content-center align-items-center w-75">
              <img
                src="./images/myconsoleLogo.png"
                alt=""
                className="w-50 mt-5"
              />
            </div>
            <div className="d-flex justify-content-center align-items-center mt-5 w-100">
              <div className="px-3">
                <h3 className="welcome-heading mb-4">Welcome to myConsole</h3>
                <div className="mt-4">
                  <InputTextElementElement
                    debounceTimeout={1}
                    placeholder="Username"
                    name="username"
                    onChange={(e) => handleEvent(e)}
                    className="mc-input w-100"
                  />
                </div>
                <div className="mt-4 login-icon">
                  <InputTextElementElement
                    debounceTimeout={1} // Set this to 1 if debounce not needed
                    placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    onChange={(e) => handleEvent(e)}
                    className="mc-input w-100 password-input"
                    ref={passwordRef}
                  />
                  {passwordRef.current?.value && (
                  <i
                    className={`eye-icon pi ${showPassword ? "pi-eye-slash" : "pi-eye"}`}
                    onClick={togglePasswordVisibility}
                  />
                  )}
                </div>

                <div className="d-flex justify-content-end">
                  <ButtonElement
                    label="Forgotten your password?"
                    onClick={handleForgotPassword}
                    className="px-0 forgot-password"
                  />
                </div>
                {message && message ? (
                  <Message severity="error" text={message} />
                ) : null}
                <div className="d-flex mt-4 mb-5">
                  <ButtonElement
                    label="Sign In"
                    severity="help"
                    className="w-100 login-btn"
                    onClick={(e) => handleSubmit(e)}
                  />
                  {loader && loader ? <Loader loading={loader} /> : ""}
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-3">
              <div className="px-1">
                <p>© myConsole Ltd</p>{" "}
              </div>
              <div className="px-1">
                <p>
                  <Link to={"/securityPolicies"}>Privacy Policy</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
